/**
 * Client accounts: the client's own profile, contacts and credit; the admin client list, adding a
 * client, and the client page that hosts every module's tab (web/src/modules.js adminClientTabs).
 */
const page = (load, name) => () => load().then((m) => ({ Component: m[name] }));
const account = () => import('./account.jsx');
const admin = () => import('./admin.jsx');
const setup = () => import('./setup.jsx');
const invites = () => import('./invites.jsx');

export default {
  name: 'clients',
  publicRoutes: [{ path: 'contacts/invite', bare: true, lazy: page(invites, 'AcceptInvite') }],
  clientRoutes: [
    { path: 'account', lazy: page(account, 'Profile') },
    { path: 'account/contacts', lazy: page(account, 'Contacts') },
    { path: 'account/credit', lazy: page(account, 'CreditHistory') },
  ],
  adminRoutes: [
    { path: 'clients', lazy: page(admin, 'AdminClients') },
    { path: 'clients/new', lazy: page(admin, 'NewClient') },
    { path: 'clients/setup', lazy: page(setup, 'ClientSetup') },
    { path: 'clients/:uuid', lazy: page(admin, 'AdminClient') },
  ],
  clientNav: [
    { key: 'account', to: '/account', order: 80, auth: true },
    { key: 'contacts', to: '/account/contacts', label: 'Contacts', order: 81, auth: true },
  ],
  adminNav: [
    { section: 'clients', to: '/admin/clients', label: 'Clients', permission: 'admin.clients.read', order: 10 },
  ],
};
